import { YOUTUBE_POST_STATUS } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function youtubePostStatus(state=INITIAL_STATE, action) {
 
  switch(action.type) {
    case YOUTUBE_POST_STATUS:
     
      // const parsedData = JSON.parse(action.payload.data)
     console.log("THE POST ENGAGEMENT DATA",action.payload)
      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}
